import { Text } from '@mantine/core';
import { useTranslationMipManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import { InlineLoader } from '@dealstack/frontend/shared/components/loaders/InlineLoader/InlineLoader';
import { DataKYCFileTctWithFile, GetKYCInvestorInstanceRes } from '@dealstack/shared/lib/generated';
import { useFormsCategoryList } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ManageKYC/ReviewKycWorkflow/component/FormsCategoryList/useFormsCategoryList';
import { CategoryGroupSection } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ManageKYC/ReviewKycWorkflow/component/FormsCategoryList/CategoryGroupSection';
import { UncategorizedFilesSection } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ManageKYC/ReviewKycWorkflow/component/FormsCategoryList/UncategorizedFilesSection';
import {
	Container,
	Inner,
} from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ManageKYC/ReviewKycWorkflow/component/FormsCategoryList/styled';
import {
	FormReviewCardData,
	SelectedTemplate,
} from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ManageKYC/ReviewKycWorkflow/component/FormsCategoryList/types.ts';
import { Step } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ManageKYC/types';

interface Props {
	mipId?: string;
	currentStep?: Step;
	currentInvestor?: GetKYCInvestorInstanceRes;
	selectedTemplate?: SelectedTemplate;
	onSelectForm: (card: FormReviewCardData) => void;
	selectedKycFileId?: string;
	onSelectFile?: (file: DataKYCFileTctWithFile) => void;
	isReadOnly?: boolean;
}

export const FormsCategoryList = ({
	mipId,
	currentStep,
	currentInvestor,
	selectedTemplate,
	onSelectForm,
	selectedKycFileId,
	onSelectFile,
	isReadOnly = false,
}: Props) => {
	const tMipManage = useTranslationMipManage();
	const { isLoading, groups, uncategorizedFiles } = useFormsCategoryList({
		mipId,
		currentInvestor,
	});

	if (isLoading) {
		return (
			<Container>
				<InlineLoader />
			</Container>
		);
	}

	return (
		<Container>
			<Inner>
				{groups.length === 0 && (
					<Text size="B6" c="dark.2">
						{tMipManage('kyc.review.forms.no_forms_configured')}
					</Text>
				)}

				{groups.map((group) => (
					<CategoryGroupSection
						key={group.key}
						group={group}
						selectedTemplateId={selectedTemplate?.templateId}
						onSelectForm={onSelectForm}
						showDivider
					/>
				))}

				<UncategorizedFilesSection
					files={uncategorizedFiles}
					currentStep={currentStep}
					currentInvestor={currentInvestor}
					selectedKycFileId={selectedKycFileId}
					onSelectFile={onSelectFile}
					isReadOnly={isReadOnly}
				/>
			</Inner>
		</Container>
	);
};
